import React from "react"
import { Anchor } from "./link";

export let RequiredSymbol = (props: {}) => <i className="fa fa-asterisk text-danger" style={{ fontSize: "0.5em", verticalAlign: "top" }} />;

export let Highlighted = (props: { text: string, match: string | null }) => {
    const match = props.match || "";
    const text = props.text || "";
    let index = text.toUpperCase().indexOf(match.toUpperCase());
    const pre = index > -1 ? text.substr(0, index) : text;
    const m = index > -1 ? match : "";
    const post = index > -1 ? text.substr(index + m.length) : "";
    return (
        <span>
            <span>{pre}</span><strong>{m}</strong><span>{post}</span>
        </span>
    );
}

export const FavSelector = (props: { selected: boolean, onChange: (selected: boolean) => void }) => <Anchor
    onClick={() => props.onChange(!props.selected)}
    className={props.selected ? "text-info fas fa-star" : "text-info far fa-star"}
    style={{ fontSize: "1.3em" }}
    title={props.selected ? "Rimuovi Predefinito" : "Imposta predefinito"}
/>